import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const ExpenseCategoryConfigurationRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--settings--expense-category-configuration']}>
    <Route path='*' element={<Index />} />
  </SubRouter>
))
